import { Component } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import Loader from '../../../../Components/Loader';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { FormRow } from '../../../../Components/Common Components/CommonRenderFields';
import { CheckAccessFunc } from "../../../../Components/CommonFunctions/CommonFunctions";

export default class DocMensuralHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            AgeatMenarche: "",
            AgeatMenopause: "",
            ChildBirthAbortion: "",
            MensuralCycle: "",
            Regularity: "",
            Bleeding: "",
            Clots: "",
            Pain: "",
            Moodswings: "",
            Complications: "",
            doctor_id: null,
            withOutAppointment: {},
        };
    }
    componentDidMount() {
        let clinicId = getCachevalue('SelectedDoctorClinic')
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        const ipPatientData = JSON.parse(getCachevalue("IppatientData"));
        const appointmentDetail = JSON.parse(getCachevalue("withoutAppointment"));
        this.setState({
            clinicId: clinicId,
            appointmentId: appointmentId?.appointment_id,
            patientId: appointmentId?.patient_id || ipPatientData?.patient_id,
            patientDetails: appointmentId,
            doctor_id: ipPatientData?.doctor_id,
            withOutAppointment: appointmentDetail?.patient_id === ipPatientData?.patient_id
                ? appointmentDetail
                : null,
        }, () => {
            this.getPatientDetailData()
            this.getMensuralHistoryData()
        })
    }
    getPatientDetailData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientDetails: { ...this.state.patientDetails, ...response?.data?.data }
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    getMensuralHistoryData = () => {
        try {
            this.setState({ mensuralloading: true })
            RestAPIService.getAll(Serviceurls.DOC_BLOOD_MENSURAL_HISTORY_GET + `?patient_id=${this.state.patientId}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({ mensuralloading: false })
                        const data = response?.data?.data
                        if (Object.keys(data)?.length > 0) {
                            this.setState({
                                MensuralEdit: true,
                                AgeatMenarche: data?.age_at_menarche ? data?.age_at_menarche : "",
                                AgeatMenopause: data?.age_at_menopause ? data?.age_at_menopause : "",
                                ChildBirthAbortion: data?.child_birth ? data?.child_birth : "",
                                MensuralCycle: data?.mensural_cycle ? data?.mensural_cycle : "",
                                MensuralHistoryID: data?.id ? data?.id : null,
                                Regularity: data?.regularity || "",
                                Bleeding: data?.bleeding || "",
                                Clots: data?.clots || "",
                                Pain: data?.pain || "",
                                Moodswings: data?.mood_swings || "",
                                Complications: data?.complications || "",
                            })
                        }
                    }
                }).catch((error) => {
                    this.setState({ mensuralloading: false })
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.setState({ mensuralloading: false })
            this.errorMessage(error.message)
        }
    }
    postMensuralHistoryData = () => {
        try {
            const data = {
                patient_id: this.state.patientId,
                age_at_menarche: this.state.AgeatMenarche ? Number(this.state.AgeatMenarche) : null,
                age_at_menopause: this.state.AgeatMenopause ? Number(this.state.AgeatMenopause) : null,
                child_birth: this.state.ChildBirthAbortion ? this.state.ChildBirthAbortion : "",
                mensural_cycle: this.state.MensuralCycle ? this.state.MensuralCycle : "",
                menstrual_history_id: this.state.MensuralHistoryID ? this.state.MensuralHistoryID : null,
                regularity: this.state.Regularity || "",
                bleeding: this.state.Bleeding || "",
                clots: this.state.Clots || "",
                pain: this.state.Pain || "",
                mood_swings: this.state.Moodswings || "",
                complications: this.state.Complications || "",
            }
            if (this.props.is_From_Fo) {
                data['doctor_id'] = state.doctor_id
            }
            this.setState({ mensuralloading: true })
            RestAPIService.create(data, Serviceurls.DOC_BLOOD_MENSURAL_HISTORY_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.successMessage(response.data.message)
                        this.onClearMensuralData()
                        this.getMensuralHistoryData()
                    }
                }).catch((error) => {
                    this.setState({ mensuralloading: false })
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.setState({ mensuralloading: false })
            this.errorMessage(error.message)
        }
    }
    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    onClearMensuralData = () => {
        try {
            this.setState({
                AgeatMenarche: '',
                AgeatMenopause: '',
                ChildBirthAbortion: '',
                MensuralCycle: '',
                Regularity: "",
                Bleeding: "",
                Clots: "",
                Pain: "",
                Moodswings: "",
                Complications: "",
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    onChangeHandler = (stateKey, value) => {
        switch (stateKey) {
            case "AgeatMenarche":
            case "AgeatMenopause":
                if (CommonValidation.numberOnly(value) || value === '') {
                    this.setState({ [stateKey]: value })
                }
                break;
            default:
                this.setState({ [stateKey]: value })
                break;
        }
    }

    renderTextBox = (names, disable, len, width = "25vw",) => {
        try {
            return (
                <TextField
                    size='small'
                    disabled={disable}
                    sx={{ width: width, mr: '0.5vw', mt: '0.5vw' }}
                    value={this.state[names] || ""}
                    inputProps={{ maxLength: len ? len : 250 }}
                    name={names}
                    onChange={(e) => this.onChangeHandler(names, e.target.value)}
                />
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    render() {
        const enableAdd = this.state.phyLoading || !(this.state.AgeatMenarche) || getCachevalue('DoctorUserChanged') === 'true';
        const checkuserAccess = (CheckAccessFunc("front_office", "In Patients", "History", "Mensural History", "SubTab")?.editAccess ?
            this.state.withOutAppointment?.is_ip || true && !enableAdd : !enableAdd);
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                </Box>
                <Box component={'div'} mt={'0.5vw'} height={'61.5vh'}>
                    <Box id='mensuralHistory' component={'div'} border={'1px solid lightgray'} mb={'1vw'} sx={{ backgroundColor: Colors.white }}>
                        <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'2.5vw'} display={'flex'} justifyContent={'space-between'} pl={'0.5vw'} alignItems={'center'}>
                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'History specific for female'}</Typography>
                            {this.state.MensuralEdit ?
                                <Button className='Common_Btn_Min_Width'
                                    onClick={() => this.setState({ MensuralEdit: false })}
                                >
                                    <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.5vw'} width={'1.5vw'} />
                                </Button> :
                                <Box display={'flex'}>
                                    <Button variant='contained'
                                        disabled={this.props.is_From_Fo ? !checkuserAccess : enableAdd}
                                        sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                        onClick={() => this.postMensuralHistoryData()}
                                    >Save</Button>
                                    <Button variant='outlined'
                                        sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                        onClick={() => this.onClearMensuralData()}
                                    >Clear</Button>
                                </Box>
                            }
                        </Box>
                        {this.state.mensuralloading ?
                            <Box mt={'0.5vw'} mb={'1vw'} ml={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'20vw'}><CircularProgress color='primary' /></Box> :
                            <Box component={'div'} className='eMed_history_div'>
                                <FormRow label="Age at Menarche *">
                                    {this.renderTextBox("AgeatMenarche", this.state.MensuralEdit, 2)}
                                </FormRow>
                                <FormRow label="Menstrual cycle">
                                    {this.renderTextBox("MensuralCycle", this.state.MensuralEdit, 150)}
                                </FormRow>
                                <FormRow label="Child birth/abortion">
                                    {this.renderTextBox("ChildBirthAbortion", this.state.MensuralEdit, 150)}
                                </FormRow>
                                <FormRow label="Age at menopause">
                                    {this.renderTextBox("AgeatMenopause", this.state.MensuralEdit, 2)}
                                </FormRow>
                                <FormRow label="Regularity">
                                    {this.renderTextBox("Regularity", this.state.MensuralEdit, 50)}
                                </FormRow>
                                <FormRow label="Bleeding">
                                    {this.renderTextBox("Bleeding", this.state.MensuralEdit, 50)}
                                </FormRow>
                                <FormRow label="Clots">
                                    {this.renderTextBox("Clots", this.state.MensuralEdit, 50)}
                                </FormRow>
                                <FormRow label="Pain">
                                    {this.renderTextBox("Pain", this.state.MensuralEdit, 50)}
                                </FormRow>
                                <FormRow label="Mood swings">
                                    {this.renderTextBox("Moodswings", this.state.MensuralEdit, 50)}
                                </FormRow>
                                <FormRow label="Complications">
                                    {this.renderTextBox("Complications", this.state.MensuralEdit, 50)}
                                </FormRow>
                            </Box>
                        }

                    </Box>

                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}